export enum MenuLocation {
    List = 1,
    Sidebar = 2,
    Profile = 3
}